import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlignHorizontalRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"align_horizontal_right"}/>
}
